import {
    StepEvent,
    Step,
    Button,
    ClickEvent,
    Layout,
    SlideoutDecorator,
    TableRow,
} from "@mcleod/components";
import { AutogenLayoutMultiSendLoadTenderStepper } from "./autogen/AutogenLayoutMultiSendLoadTenderStepper";

export class MultiSendLoadTenderStepper extends AutogenLayoutMultiSendLoadTenderStepper {

    override onLoad(): void {
        this.removeStepClickListeners(this.stepSendTender);
        this.removeStepClickListeners(this.stepTenderResults);
    }

    public static async showSlideout(selectedRows: TableRow[]) {
            const payee_id = selectedRows[0].data.get("carrier_id");
            const multiRateConProps = selectedRows.map(row => {
                const modelRow = row.data;
                return {
                    ...modelRow.data,
                    default_contact: modelRow.get("carrier_contact"),
                    default_email_address: modelRow.get("carrier_contact_email"),
                    vendor_id: "H"
                };
            });
    
            const saveButton = new Button({
                id: "buttonSendSelected",
                caption: "Send Now",
                onClick: async (event: ClickEvent) => {
                    layout.layoutMultiSendLoadTender.buttonSendSelectedTendersOnClick(event);
                    const nextIndex = layout.stepperMultiSendLoadTender.selectedIndex + 1;
                    saveButton.visible = false;
                    layout.stepperMultiSendLoadTender.selectedIndex = nextIndex;
                    layout.layoutMultiSendLoadTender.sourceSendTenders = layout.layoutMultiLoadTenderResults.mainDataSource;
                    selectedRows[0].table.selectedRows = [];
                },
                backgroundColor: "primary",
                color: "primary.reverse",
                minWidth: 128,
                borderWidth: 0,
                rowBreak: false
            })
    
            const layout = Layout.getLayout("lme/dispatch/MultiSendLoadTenderStepper") as MultiSendLoadTenderStepper;
           
            return new SlideoutDecorator({
                title: "Multi-Select Send Load Tenders",
                layout: layout,
                width: "85%",
                fillVerticalSpace: true,
                doAfterSlideIn: async (decorator: SlideoutDecorator) => {
                    layout.layoutMultiSendLoadTender.sendSelectedButton = saveButton;
                    layout.layoutMultiSendLoadTender.previewLoadTenders(multiRateConProps, payee_id);
                    layout.layoutMultiSendLoadTender.sourceSendTenders = layout.layoutMultiLoadTenderResults.mainDataSource;
                },
                onClose: async (cancelled: boolean) => {
                    layout.slideOut();
                },
                addlComponents: [saveButton]
            });
        }

    removeStepClickListeners(step: Step) {
        const clickListenersLabel = Object.assign([], step["_headingLabel"].getListeners("_clickListeners")?.listeners);
        for (const listener of clickListenersLabel) {
            step["_headingLabel"].removeClickListener(listener);
        }
        const numberLabelClicks = Object.assign([], step["_heading"].components[0]?.getListeners("_clickListeners")?.listeners);
        for (const listener of numberLabelClicks) {
            step["_heading"].components[0].removeClickListener(listener);
        }
    }

    stepperMultiAssignmentBeforeStepListener(event: StepEvent) {
        //dont allow to go backwards
        if (event.newIndex < event.oldIndex) {
            event.preventDefault();
                return;
        }

    }

}